import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { HeadingLevel } from '../../../../subcomponents';
import { EventDescription } from '../../description/event-description';
import { EventImageMediaType } from '../../image';
import { EventImage } from '../../image/event-image';
const b = bemClassBuilder('v-event-details-summary');
export const EventDetailsSummary = observer(props => {
    const { displayText, event, config, cdnOptions } = props;
    const { poster } = config;
    const hasSchedule = !!(event.schedule.startDate || event.schedule.endDate);
    return (_jsxs("div", Object.assign({ className: b.block({ hasSchedule }) }, { children: [poster.show && (_jsx(EventImage, { config: { mediaType: EventImageMediaType.Poster }, cdnOptions: { eventImage: cdnOptions.posterImage } })), _jsx(EventDescription, { displayText: { label: displayText.descriptionLabel }, config: { labelHeadingLevel: HeadingLevel.H3 } })] })));
});
EventDetailsSummary.displayName = 'EventDetailsSummary';
